export default function EmptyState({ icon: Icon, title, description, action = null }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-[rgba(var(--border),_0.6)] bg-[rgba(var(--panel),_0.45)] px-10 py-12 text-center shadow-[0_10px_30px_rgba(var(--shadow),_0.1)]">
      {Icon ? <Icon className="h-12 w-12 text-[rgba(var(--fg),_0.5)]" aria-hidden="true" /> : null}
      <div className="space-y-2">
        <h3 className="text-lg font-semibold text-[rgb(var(--fg))]">{title}</h3>
        {description ? <p className="text-sm text-[rgba(var(--fg),_0.7)]">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}
